export default {
  page_title: '搜尋幫助',
  t_operators: '使用搜尋運算子',
  t_precedence: '搜尋運算子優先序',
  operators: [
    '搜尋運算子 (search operators) 為特別的搜尋用詞、以便更有效掌握你的搜尋範圍。你可以於本網站頂部及首頁搜尋欄位中使用以下運算子。本部分暫時未被翻譯、敬請注意。',
    '若在同一項搜尋中使用多於一個運算子，該項查詢將用以下的順序處理：'
  ],
}